var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lv-divider",style:({
    'margin-top': _vm.marginTop,
    'margin-bottom': _vm.marginBottom,
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }